import React from "react";

const PermissionDeny = () => {
  return <h3 className="text-danger">Permission is denied</h3>;
};

export default PermissionDeny;
